// @ts-check
// Onde a novidade da versão aparece (contrato 08-contrato-novidades.md, seção 4). Puro: o balão acima da versão no
// rodapé da gaveta expandida, o cartão no celular e com o trilho recolhido (escondido enquanto há seleção), ou nada.
// O balão e o cartão leem a mesma resposta, então nunca aparecem juntos, e trocar de forma (gaveta expandida ou
// recolhida) não marca a versão como vista.
import { RELEASE_NOTES_BALLOON_HIGHLIGHT_LIMIT } from '../../../shared/release-notes/release-notes.js';

/**
 * @typedef {{ hasAnnouncement: boolean, isSupport: boolean, isReady: boolean, routeName: string, isMobile: boolean,
 *   isDrawerExpanded: boolean, isEditingNavigation: boolean, isBottomChromeHidden: boolean, hasActiveSelection: boolean,
 *   hasOpenModal: boolean }} ReleaseNotesSurfaceInput
 * @typedef {'balloon' | 'card' | null} ReleaseNotesSurface
 */

/**
 * @param {ReleaseNotesSurfaceInput} input
 * @returns {ReleaseNotesSurface}
 */
export function resolveReleaseNotesSurface(input) {
  if (!input.hasAnnouncement || input.isSupport || !input.isReady) return null;
  // a página já mostra tudo; com o menu em edição ou um diálogo aberto, o aviso esperaria a vez
  if (input.routeName === 'releaseNotes' || input.isEditingNavigation || input.hasOpenModal) return null;
  // a barra de seleção ocupa o rodapé da tela: o cartão cobriria a primeira ação dela (no celular e com o trilho)
  if (!input.isMobile) {
    if (input.isDrawerExpanded) return 'balloon';
    return input.hasActiveSelection ? null : 'card';
  }
  // no celular o cartão fica acima da barra flutuante e some com ela
  if (input.isBottomChromeHidden || input.hasActiveSelection) return null;
  return 'card';
}

/**
 * Títulos que o balão lista: os primeiros destaques da versão, na ordem do catálogo.
 * @param {import('../../../shared/release-notes/release-notes.js').ReleaseNote | null | undefined} entry
 */
export function balloonHighlights(entry) {
  return entry ? entry.highlights.slice(0, RELEASE_NOTES_BALLOON_HIGHLIGHT_LIMIT) : [];
}
